import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Translation } from 'react-i18next';
import i18n from 'i18next';
import Loading from '../utility/Loading';
import { makePDF } from '../../pdf';
import { getDegreeClassesByYear } from './GetDegreeClassesByYear';
import ecapPDFPreview from '../../ASUPhotos/EcapPDFPreview.jpg';
import { handleFireGTM } from '../utility/routeUtil';
import {
  getCoreSubjectStrings2,
  getAdditionalElectiveString,
} from '../../copy/ecap/classesSetupStrings';
import { getRequiredClassesByAcadPlan } from './classes/drag-drop/dragDropUtil';
import { getEcapState } from '../../store/selectors';

class CompletePlan extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      pdf: null,
      err: null,
      loading: true,
    };
  }

  getClassesPerAcadPlan = async (acadPlan) => {
    const classesPerAcadPlan = await getRequiredClassesByAcadPlan(
      acadPlan,
      this.props.acadPlanClasses
    );
    return classesPerAcadPlan;
  };

  componentDidMount = async () => {
    const degree1 = await getDegreeClassesByYear(
      await this.getClassesPerAcadPlan(
        this.props.onboarding.degreeChoices[1].acadPlan
      )
    );
    const degree2 = await getDegreeClassesByYear(
      await this.getClassesPerAcadPlan(
        this.props.onboarding.degreeChoices[2].acadPlan
      )
    );
    const degree3 = await getDegreeClassesByYear(
      await this.getClassesPerAcadPlan(
        this.props.onboarding.degreeChoices[3].acadPlan
      )
    );
    const ecapColors = {
      primary: this.props.tenant.primary,
      secondary: this.props.tenant.secondary,
      largerGreyHeader: 'grey',
      tableBorders: '#dbdbdb',
      tableFillColor: '#F7F7F7',
    };
    const degreeColors = {
      greyText: '#555555',
      backgroundGrey: '#F7F7F7',
      tableBorders: '#dbdbdb',
      secondary: this.props.tenant.secondary,
    };
    const ecapPDFCopy = {
      mainHeader: i18n.t('Education and Career Action Plan'),
      topText1: i18n.t(' Name:'),
      topText2: i18n.t('Student Number:'),
      topText3: i18n.t('Graduation Class:'),
      topText4: i18n.t(' Counselor:'),
      year1: i18n.t('Year {{number}}', { number: '1' }),
      year1subhead: `(${i18n.t('Freshman', { context: 'Academic' })})`,
      year2: i18n.t('Year {{number}}', { number: '2' }),
      year2subhead: `(${i18n.t('Sophomore', { context: 'Academic' })})`,
      year3: i18n.t('Year {{number}}', { number: '3' }),
      year3subhead: `(${i18n.t('Junior', { context: 'Academic' })})`,
      year4: i18n.t('Year {{number}}', { number: '4' }),
      year4subhead: `(${i18n.t('Senior', { context: 'Academic' })})`,
      english: getCoreSubjectStrings2().english,
      math: getCoreSubjectStrings2().math,
      laboratoryScience: getCoreSubjectStrings2().science,
      socialScience: getCoreSubjectStrings2().socialStudies,
      fineArts: getCoreSubjectStrings2().fineArts,
      foreignLanguage: getCoreSubjectStrings2().foreignLanguage,
      electives: getCoreSubjectStrings2().electives,
      additionalElectives: getAdditionalElectiveString(),
      englishTableHeader: i18n.t(' - 4 years (composition/literature based)'),
      mathTableHeader: i18n.t(
        ' - 4 years - Algebra I, Geometry, Algebra II, & one course requiring Algebra II as a prerequisite'
      ),
      laboratoryScienceTableHeader: i18n.t(
        ' - 3 years total (one year each from any of the following are accepted: Biology, Chemistry, Earth Science, Integrated Sciences, and Physics)'
      ),
      socialScienceTableHeader: i18n.t(
        ' - 2 years (including one year American History - AZ/U.S.'
      ),
      fineArtsTableHeader: i18n.t(' - 1 year'),
      coursesExplanation: i18n.t(
        'These courses represent undergraduate admission requirements for the Arizona University System. Please speak to a college representative about specific admissions requirements for the program that interests you.'
      ),
      checkboxCollegeOption1: i18n.t(
        'Community College and transfer to university'
      ),
      checkboxCollegeOption2: i18n.t('4 year degree at university'),
      checkboxCollegeOption3: i18n.t('2 year degree at university'),
      checkboxCollegeOption4: i18n.t('Vocational/Technical School'),
      checkboxCollegeOption5: i18n.t('Military Service'),
      checkboxCollegeOption6: i18n.t('Work'),
      checkboxCollegeOption7: i18n.t('Undecided'),
      checkboxFinancialAidOption1: i18n.t('Loans'),
      checkboxFinancialAidOption2: i18n.t('Scholarships'),
      checkboxFinancialAidOption3: 'FAFSA',
      checkboxFinancialAidOption4: i18n.t('Grants'),
      checkboxFinancialAidOption5: i18n.t('Other'),
      ecapText: i18n.t('Education and Career Action Plan'),
      coursesText: i18n.t('Courses', { context: 'Academic' }),
      collegeText: i18n.t('College'),
      ecapReviewText: i18n.t('Education and Career Action Plan Review'),
      ecapPayForCollegeText: i18n.t('Ways I Can Pay For College'),
      applicationStatusText: i18n.t('Application Status'),
      applicationCompletedText: i18n.t('Application Complete'),
      deadlineText: i18n.t('Deadline'),
      chooseOne: i18n.t('Choose One'),
      chooseAll: i18n.t('Choose All That Apply'),
      activityText: i18n.t('Activity'),
      startText: i18n.t('Start'),
      endText: i18n.t('End'),
      activitiesHeader: i18n.t(
        'Volunteer, Extra-Curricular Activities, Work Experience and Achievements'
      ),
      volunterServiceText: i18n.t('Volunteer Experience'),
      extraCurricularText: i18n.t('Extra-Curricular Activities'),
      workExperienceText: i18n.t('Work Experience'),
      achievementsText: i18n.t('Achievements'),
      academicStatisticsText: i18n.t('Academic Statistics'),
      acstats1: 'GPA:',
      acstats2: 'ACT:',
      acstats3: 'SAT:',
      acstats4: i18n.t('Class Rank:', { context: 'Academic' }),
      dateText: i18n.t('Date:'),
      counselorText: i18n.t('Counselor:'),
      freshmenDateText: `${i18n.t('Year {{number}}', {
        number: '1',
      })} (${i18n.t('Freshman', { context: 'Academic' })}):`,
      sophomoreDateText: `${i18n.t('Year {{number}}', {
        number: '2',
      })} (${i18n.t('Sophomore', { context: 'Academic' })}):`,
      juniorDateText: `${i18n.t('Year {{number}}', { number: '3' })} (${i18n.t(
        'Junior',
        { context: 'Academic' }
      )}):`,
      seniorDateText: `${i18n.t('Year {{number}}', { number: '4' })} (${i18n.t(
        'Senior',
        { context: 'Academic' }
      )}):`,
      parentGuardianText: i18n.t('Parent/Guardian:'),
    };

    const degreeRequirementsCopy = {
      otherClass: i18n.t('Elective', { context: 'Academic Subjects' }),
      requirementsHeader: i18n.t('Degree Requirements Summary'),
      institutionName: 'Arizona State University',
      tableHeader1: i18n.t('Subject'),
      tableHeader2: i18n.t('Year {{number}}', { number: 1 }),
      tableHeader3: i18n.t('Year {{number}}', { number: 2 }),
      tableHeader4: i18n.t('Year {{number}}', { number: 3 }),
      tableHeader5: i18n.t('Year {{number}}', { number: 4 }),
      coreSubjectStrings: getCoreSubjectStrings2(),
    };

    if (degree1 && degree2 && degree3) {
      makePDF('ecap', {
        ecap: {
          user: this.props.onboarding.userData.user,
          ecapData: this.props.ecap.plan,
          colors: ecapColors,
          copy: ecapPDFCopy,
        },

        deg1: {
          degreeTitle:
            this.props.onboarding.degreeChoices[1].titleEn || degree1.titleEn,
          year1: degree1.year1,
          year2: degree1.year2,
          year3: degree1.year3,
          year4: degree1.year4,
          colors: degreeColors,
          copy: degreeRequirementsCopy,
        },
        deg2: {
          degreeTitle:
            this.props.onboarding.degreeChoices[2].titleEn || degree2.titleEn,
          year1: degree2.year1,
          year2: degree2.year2,
          year3: degree2.year3,
          year4: degree2.year4,
          colors: degreeColors,
          copy: degreeRequirementsCopy,
        },
        deg3: {
          degreeTitle:
            this.props.onboarding.degreeChoices[3].titleEn || degree3.titleEn,
          year1: degree3.year1,
          year2: degree3.year2,
          year3: degree3.year3,
          year4: degree3.year4,
          colors: degreeColors,
          copy: degreeRequirementsCopy,
        },
      })
        .then((data) => {
          this.setState({ pdf: URL.createObjectURL(data) });
        })
        .catch((err) => {
          this.setState({ err });
        })
        .finally(() => {
          this.setState({ loading: false });
          // Do not focus on button to let voice over announce any kind of assertion
          // document.getElementById('complete-plan-modal-actions-button').focus();
        });
    }
  };

  secondaryBackground = {
    backgroundColor: `${this.props.tenant.secondary}`,
  };

  primaryBackground = {
    backgroundColor: `${this.props.tenant.primary}`,
  };

  primaryColor = {
    color: `${this.props.tenant.primary}`,
  };

  disabled = {
    color: 'white',
  };

  onClickClose = () => {
    if (this.state.loading) return;

    this.props.onClose();
  };

  handleRoutingGTM = () => {
    handleFireGTM(
      this.props.tenant.name,
      'click "download my plan"',
      this.props.location.pathname
    );
  };

  render() {
    const { pdf, loading, err } = this.state;

    // if we run into an error with the pdf, we force an error to show the user the error screen
    if (err) {
      console.log('err: ', err);

      return { err };
    }

    return (
      <Translation>
        {(t) => (
          <div className="complete-plan" id="pdf-component">
            <div
              className="complete-plan__background"
              onClick={this.onClickClose}
              role="presentation"
              onKeyDown={(e) => {
                if (['Enter'].includes(e.key)) this.onClickClose();
              }}
            />
            <div className="complete-plan__modal">
              <div
                className="complete-plan__modal-heading"
                aria-live="assertive"
              >
                {t('Congratulations!')}
                <br />
                {t('Your Education and Career Action Plan is now complete.')}
              </div>
              <div className="complete-plan__modal-subheading">
                {t(
                  'You can download a PDF of your plan by clicking the button below.'
                )}
              </div>
              <div className="complete-plan__modal-subheading">
                {t(
                  'If you are not ready to download your plan, you can go back and edit your selections or go to your dashboard.'
                )}
              </div>
              <div
                className="complete-plan__modal-bar"
                style={this.secondaryBackground}
              />
              <div className="complete-plan__modal-preview">
                {loading ? (
                  <Loading height="100%" />
                ) : (
                  <img
                    className="complete-plan__modal-preview_pdf"
                    src={ecapPDFPreview}
                    alt="Education Plan PDF Preview"
                  />
                )}
              </div>
              <div className="complete-plan__modal-actions">
                <div className="complete-plan__modal-actions_buttons">
                  <button
                    disabled={loading}
                    type="button"
                    tabIndex={0}
                    id="complete-plan-modal-actions-button"
                    className="complete-plan__modal-actions_button"
                    style={
                      loading || !pdf ? this.disabled : this.primaryBackground
                    }
                    onClick={() => {
                      this.handleRoutingGTM();
                      window.open(pdf, '_blank');
                    }}
                    onKeyDown={(e) => {
                      if (['Enter'].includes(e.key)) window.open(pdf, '_blank');
                    }}
                  >
                    {t('Download My Plan')}
                  </button>
                  <button
                    type="button"
                    className="complete-plan__modal-actions_button"
                    style={
                      loading || !pdf ? this.disabled : this.primaryBackground
                    }
                    onClick={() => {
                      this.onClickClose();
                    }}
                    onKeyDown={(e) => {
                      if (['Enter'].includes(e.key)) this.onClickClose();
                    }}
                  >
                    {t('Edit My Plan')}
                  </button>
                </div>
                <div className="complete-plan__modal-actions_buttons">
                  <button
                    type="button"
                    tabIndex={0}
                    onClick={() => {
                      this.props.history.push('dashboard');
                    }}
                    onKeyDown={(e) => {
                      if (['Enter'].includes(e.key))
                        this.props.history.push('dashboard');
                    }}
                    className="complete-plan__modal-actions_link"
                    style={loading || !pdf ? this.disabled : this.primaryColor}
                  >
                    {t('Go To Dashboard')}
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </Translation>
    );
  }
}

const CompletePlanWithRouter = withRouter(CompletePlan);

const mapStateToProps = (state) => {
  const tenant = state.tenant;
  const onboarding = state.onboarding;
  const ecap = getEcapState(state);
  const auth = state.auth;

  return { tenant, onboarding, ecap, auth };
};

export default connect(mapStateToProps)(CompletePlanWithRouter);
